/*
 *
 * File actions
 *
 */

import {
    DOWNLOAD_FILE,
    SAVE_FILE,
    SAVE_FILE_PROGRESS,
    SAVE_FILE_SUCCESS,
    SAVE_FILE_ERROR,
    GET_IMAGE_LINK,
    SET_DOWNLOAD_LINK,
    CLEAR_DOWNLOAD_LINK,
} from './constants';

export function downloadFile(fileId) {
    return {
        type: DOWNLOAD_FILE,
        payload: {fileId},
    };
}

export function saveFile(file, meta) {
    return {
        type: SAVE_FILE,
        meta,
        payload: {file},
    };
}

export function fileSavingProgress(progress, meta) {
    return {
        type: SAVE_FILE_PROGRESS,
        meta,
        payload: {progress},
    };
}

export function fileSaved(fileId, meta) {
    return {
        type: SAVE_FILE_SUCCESS,
        meta,
        payload: {fileId},
    };
}

export function fileSavingError(error, meta) {
    return {
        type: SAVE_FILE_ERROR,
        meta,
        payload: {error},
    };
}

export function getImageLink(fileId, meta) {
    return {
        type: GET_IMAGE_LINK,
        meta,
        payload: {fileId},
    };
}

export function setDownloadLink(link, meta) {
    return {
        type: SET_DOWNLOAD_LINK,
        meta,
        payload: {link},
    };
}

export function clearDownloadLink(meta) {
    return {
        type: CLEAR_DOWNLOAD_LINK,
        meta,
    };
}